import React from 'react';

// Full-width notice strips shared by Truck Availability and the SOB panel. One line high where
// the text allows, so a notice never stretches the toolbar above a grid (the earlier warning was
// stacked inside the toolbar and pushed the whole grid down).
var STRIP_STYLES = {
    warn: { color: "#7a3e00", background: "#fff4e5", border: "1px solid #f5c58a", borderLeft: "4px solid #f59e0b" },
    info: { color: "#0b3a6b", background: "#eef6ff", border: "1px solid #b6d4f5", borderLeft: "4px solid #1976d2" }
};

export function renderNoticeStrip(kind, content, key) {
    var palette = STRIP_STYLES[kind] || STRIP_STYLES.info;
    return (
        <div key={key} role="status" style={Object.assign({
            display: "flex", alignItems: "flex-start", gap: "8px", width: "100%",
            fontSize: "12.5px", lineHeight: "18px", borderRadius: "6px",
            padding: "6px 10px", margin: "0 0 8px 0", flexShrink: 0
        }, palette)}>
            <span style={{ fontWeight: 700 }}>{kind === "warn" ? "⚠" : "ⓘ"}</span>
            <div style={{ flex: 1, minWidth: 0 }}>{content}</div>
        </div>
    );
}

// Trucks that planning will NOT use for this warehouse, grouped by reason (Node
// getLmTrucksDetails / getPRTTruckAvailableData with_ignored, rule truckPlanningIgnoreReason):
// another warehouse's category on a shared plant, no zone earmarked, a size the engine never
// fetches, or added on the Truck Details screen. Listing them as supply made trucks look free
// that SOB could never allocate - so they are named here instead (client, 2026-10-19).
// A manual count has no real vehicle number (Node sends source 'Manual'), so it is shown as a count.
export function renderIgnoredTrucksNotice(ignored, loadingPortCode) {
    if (!Array.isArray(ignored) || ignored.length === 0) { return ""; }
    var groups = {};
    var order = [];
    ignored.forEach(function (t) {
        var reason = t.reason || "Not used by planning";
        if (!groups[reason]) { groups[reason] = []; order.push(reason); }
        groups[reason].push(t);
    });
    var MAX_LISTED = 6;
    var n = ignored.length;
    return renderNoticeStrip("warn",
        <React.Fragment>
            <b>{n} truck{n === 1 ? "" : "s"} today {n === 1 ? "is" : "are"} not counted
                for {loadingPortCode || "this warehouse"}</b> - planning and SOB do not use {n === 1 ? "it" : "them"}:
            {order.map(function (reason) {
                var list = groups[reason];
                var manual = list.filter(function (t) { return t.source === "Manual"; });
                var others = list.filter(function (t) { return t.source !== "Manual"; });
                var shown = others.slice(0, MAX_LISTED).map(function (t) {
                    var bits = [t.vehicle_type, t.zone].filter(function (x) { return x; }).join(", ");
                    return (t.vehicle_number || "no number") + (bits ? " (" + bits + ")" : "");
                });
                if (manual.length > 0) {
                    shown.push(manual.length + " manual count" + (manual.length === 1 ? "" : "s"));
                }
                return (
                    <div key={reason} style={{ marginTop: "2px" }}>
                        &bull; {reason} - {list.length}: {shown.join("; ")}
                        {others.length > MAX_LISTED ? " +" + (others.length - MAX_LISTED) + " more" : ""}
                    </div>
                );
            })}
        </React.Fragment>, "ignored-trucks");
}
